import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import usersStore from '@/store/users';
import authenticator from '@/store/authentication';

@Component
export default class ChangePassword extends Vue {

    // User Id
    @Prop({ default: '' }) private readonly id?: string;

    private currentPassword = '';
    private newPassword = '';

    get loading(): boolean {
        return appStore.isLoading;
    }

    private async change() {

        if (!authenticator.isLoggedIn) {
            appStore.error({ message: 'L\'utente non è autenticato. Impossibile cambiare la password.'});
            return;
        }

        if (this.currentPassword === this.newPassword) {
            appStore.error({ message: 'Non è possibile utilizzare la stessa password.'});
            return;
        }

        const userId = this.id ? this.id : authenticator.userProfile.sub;

        await this.changePasswordAsync(userId);
    }

    private async changePasswordAsync(userId: string) {

        await usersStore.changePasswordAsync(
            {
                id: userId,
                currentPassword: this.currentPassword,
                newPassword: this.newPassword,
            })
            .then(() => { this.$emit('close'); })
            .catch((reason) => {
                appStore.error({ message: 'Spiacenti. Password non modificata.' });
            });
    }
}